import Vue from 'vue';
import PrizeCompetition from './prize-competition/prize-competition.vue';
Vue.component('prize-competition', PrizeCompetition);
